import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/disclaimer',
        name: 'Disclaimer',
        component: () => import('../views/Disclaimer.vue'),
    },
    {
        path: '/imprint',
        name: 'Imprint',
        component: () => import('../views/Imprint.vue'),
    },
    {
        path: '/privacy-policy',
        name: 'PrivacyPolicy',
        component: () => import('../views/PrivacyPolicy.vue'),
    },
];

const router = new VueRouter({
    mode: 'history',
    base: __dirname,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
});

export default router;
